import { render, staticRenderFns } from "./AlimentationPositiveDurable.vue?vue&type=template&id=4a26dc7a&scoped=true"
import script from "./AlimentationPositiveDurable.vue?vue&type=script&lang=js"
export * from "./AlimentationPositiveDurable.vue?vue&type=script&lang=js"
import style0 from "./AlimentationPositiveDurable.vue?vue&type=style&index=0&id=4a26dc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26dc7a",
  null
  
)

export default component.exports